import 'core-js/modules/es.string.replace-all'
import 'core-js/modules/es.array.at.js'
  
import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { Layout } from '@/components/Layout'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import * as actions from '@globalActions'

import { GlobalStyle } from './style'

const App = props => {
    return (
        <Layout {...props}>
            <ErrorBoundary>
                {props.children}
            </ErrorBoundary>
            <GlobalStyle />
        </Layout>
    )
}

const mapStateToProps = ({ MODAL, showWizard, drupalHost, currentAct }) => ({
    MODAL, showWizard, drupalHost, currentAct
})

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(actions, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(App)